import { useTokens } from "@gemini/core";
import { useMediaQuery } from "./useMediaQuery";
/**
 * The viewport is evaluated on CSR using a "max-width: **599px**" query.
 * Returns **true** by default during SSR.
 *
 * ### Usages
 *
 * ```tsx
 * const isMobile = useIsMobile()
 *
 * ```
 * ### SSR value
 * Best practice is to always mount components during SSR, regardless of the viewport
 * To that intent, useIsMobile hook always returns true during SSR
 */
export const useIsMobile = () => {
    const tokens = useTokens();
    const sm = tokens["breakpoint.sm"] || 600;
    return useMediaQuery(`(max-width: ${sm - 1}px)`);
};
